export default __webpack_public_path__ + "static/media/SID_selfie.47e91021.png";